import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DarkModeToggleComponent } from './dark-mode-toggle.component';

@NgModule({
  declarations: [DarkModeToggleComponent],
  imports: [CommonModule, ButtonModule],
  exports: [DarkModeToggleComponent],
})
export class DarkModeToggleModule {}
